import * as Tools from '@/components/00/Tools';			// 共通ツール

//-----------------------------------------------------------------
// 変数定義 
//-----------------------------------------------------------------

export let productName = "";  // プロダクト名（メモった！、キニッタ！）
export function setProductName(val: string) { productName = val; }

export let debugEnabled = false;  // デバッグ用フラグ true/false
export function setDebugEnabled(val: boolean) { debugEnabled = val; }

//var fileAPI = false;	// File APIが利用可能な場合はtrue
// 今日の日付(Dateオブジェクト)
export let today: Date;			
export function setToday(val: Date) { today = val; }
// ユーザー種別に基づくカレンダー開始年月日(Dateオブジェクト)
export let beginDate: Date;		
export function setBeginDate(val: Date) { beginDate = val; }
// ユーザー種別に基づくカレンダー開始年月日(カレンダー設定用ISO文字列)
export let beginDateISO: string;		
export function setBeginDateISO(val: string) { beginDateISO = val; }
// ユーザー種別に基づくカレンダー終了年月日(Dateオブジェクト)
export let endDate: Date;		
export function setEndDate(val: Date) { endDate = val; }
// ユーザー種別に基づくカレンダー終了年月日(カレンダー設定用ISO文字列)
export let endDateISO: string;		
export function setEndDateISO(val: string) { endDateISO = val; }
// 表示中の年月
export let curYYYYMM = ""; 	
export function setCurYYYYMM(val: string) {curYYYYMM=val;}
// 表示中の年月日
export let curYYYYMMDD = ""; 	
export function setCurYYYYMMDD(val: string) 
{
    curYYYYMMDD=val;
    curYYYYMM=val.substring(0,6);
}

export let minYYYYMM = "";		// 表示可能な最小年月（ユーザータイプにより決定）
export function setMinYYYYMM(val: string) {minYYYYMM=val;}

export let maxYYYYMM = "";		// 表示可能な最大年月（ユーザータイプにより決定）
export function setMaxYYYYMM(val: string) {maxYYYYMM=val;}

export const curHH = ""; 	// 表示中の時刻

export let curPage = "";		// 現在表示中のページ
export function setCurPage(val: string) {curPage=val;}

export let rtnPage = "";		// 必要な時に戻りページIDを保存しておく
export function setRtnPage(val: string) {rtnPage=val;}
export function getRtnPage() { return rtnPage;}

export let autoLogin = false;	// 自動ログイン
export function setAutoLogin(val: boolean) { autoLogin = val; }

export let langCd = "ja";		// 言語コード
export function setLangCd(val: string) { langCd = val; }

export let countryCd = "JP";	// 国コード
export function setCountryCd(val: string) { countryCd = val; }

export let ttype = "";			// ログインした端末 1:Android, , 2:iOS, 3:その他(PC)
export function setTtype(val: string) { ttype = val; }

// export let userDevice: string;    // 利用しているデバイス(Andorid, iOS, その他が入る) 2023/1/21 Capacitor.getPlatform()で置き換え
export let userDeviceToken: string; // Push通知用トークン

export let registeredEmail = "";   // 新規登録したメールアドレス
export function setRegisteredEmail(val: string) { registeredEmail = val; }

// export var commonHeader: CommonHeader; // Json用共通ヘッダー

// var pageStack = new Array(); // ページ遷移履歴
export let pageStack: string[] = []; // ページ遷移履歴
// ユーザー情報一時保存領域
// local storage
export const ui_key_prefix = "ui"; // ユーザー情報
// ログイン情報保存領域
export const li_dirname = "Memotta";   // local file systemに保存する際のディレクトリ名
export const li_filename_prefix = "li";   // local file systemに保存する際のファイル名の先頭部分
// プロフィール退避用
export let yyyy_dob = "";  // 年
export let mm_dob = "";    // 月
export let dd_dob = "";    // 日
export let addr_j = "";     // 居住地コード（県）
export let addr_o = "";     // 居住地コード（海外）
// アプリ起動モード(1:通常起動、2:push通知又はダイナミックリンクによる起動)
export let runMode = "1";
export function setRunMode(val: any) {runMode=val;}

// SQLite用
export let sqlite: any;        // SQLiteコネクション
export function setSqlite(val: any) { sqlite = val; }
export let db: any;     // データーベース
export function setDb(val: any) { db = val; }
export const sqliteOKMsg = "SQLite OK";          // ログ（正常終了）
export const sqliteErrorMsg = "SQLite Error: ";  // ログ（異常終了）
// DTO
export let mst002: any = null;  // ログイン情報を保持
export function setMst002(val: any) {mst002=val;}

// カメラ、イメージ用
//var deviceReady = false; // デバイス使用可否
//var pictureSource;   	// picture source
//var destinationType; 	// sets the format of returned value
//var deviceReady = false; // デバイス使用可否

// ユーザー情報
//var liFS = null;		// ファイルシステム内のログイン情報(LoginInfoオブジェクトを格納）

// 多国語画面表示ラベル
export let lbl_title: string;	// タイトル
export function setLblTitle(val: string) { lbl_title = val; }
export let lbl_footer: string; // フッター
export function setLblFooter(val: string) { lbl_footer = val; }
export let lbl_logout: string;	// ログアウト
export function setLblLogout(val: string) { lbl_logout = val; }
export let lbl_nm: string;		// ニックネーム
export function setLblNm(val: string) { lbl_nm = val; }

// イメージリサンプリング用変数
export let orgCanvas: any;          // 退避したCanvas
export function setOrgCanvas(val: any) {orgCanvas=val;}

export let orgImgW: number;             // 退避したイメージの横幅
export function setOrgImgW(val: number) {orgImgW=val;}

export let orgImgH: number;             // 退避したイメージの高さ
export function setOrgImgH(val: number) {orgImgH=val;}

export let curRatioImg: number;       // 現在の倍率
export function setCurRatioImg(val: number) {curRatioImg=val;}

export let cntResampling: number;   // リサンプリングした回数
export function setCntResampling(val: number)  { cntResampling = val; }

// 有料プラン製品情報
export let memottaProduct: any; // ストアーから取得した製品情報が入る

// 画面初期化フラグ
export let s00001001_clear: boolean;
export function setS00001001_clear(val: boolean) {s00001001_clear = val;}

// プロフィール用画像
export let s00001003_uploadImageURI: string;  // アップロード用画像の絶対パス

// プロジェクト一覧取得結果一時退避変数
export let c000120Keep: any;       // プロジェクト一覧
export function setC000120Keep(val: any) {c000120Keep = val;}
export let c000120KeepIdx = -1;    // プロジェクト選択済みインデックス
export function setC000120KeepIdx(val: number) {c000120KeepIdx = val;}

export let numOfGroupOwned = 0;      // 所有しているグループ数
// メンバー一覧取得結果一時退避変数
export let c000040Keep: any;       // メンバー一覧
export function setC000040Keep(val: any) {c000040Keep = val;}
export let c000040KeepIdx: number;    // メンバー選択済みインデックス
export function setC000040KeepIdx(val: any) {c000040KeepIdx = val;}

// プロフィール取得結果一時退避変数
export let c000070Keep: any;       // メンバー一覧
export function setC000070Keep(val: any) {c000070Keep = val;}

export let mpt034_evntNtfyTs: any;      // イベント通知予定時刻
export function setMpt034_evntNtfyTs(val: any) { mpt034_evntNtfyTs = val; }

export let mpt202_memoNtfyTs: any;    // メモ通知予定時刻

export let curPrjNo = 0;       // 選択中のプロジェクトNo
export function setCurPrjNo(val: number) { curPrjNo = val; }

export let curEventNo = 0; 	// 表示中のイベント番号
export function setCurEventNo(val: number) { curEventNo = val; }

export let curActNo = 0; 	    // 表示中のアクション番号
export function setCurActNo(val: number) { curActNo = val; }

export let curEventHH = ""; 	// イベント開始時刻
export function setCurEventHH(val: string) { curEventHH = val; }

// Google Maps ローダー
export let mapLoader: any;
export function setMapLoader(val: any) { mapLoader = val; }

// 地図拡大表示用
export let s00001015_addr: string;    // 住所
export function setS00001015_addr(val: any) {s00001015_addr = val;}
export let s00001015_desc: string;    // 説明
export function setS00001015_desc(val: any) {s00001015_desc = val;}

// ダイナミックリンク用
export let dynamiclinkDispatcherFunc: any = null;       // dynamicLinkDispatcher用関数
export function setDynamiclinkDispatcherFunc(val: any) {dynamiclinkDispatcherFunc = val;}

// // ダイナミックリンクで起動された際にディープリンクのパスが入る
// export let deepLink: any = null;
// export function setDeepLink(val: any) { deepLink = val; }

// 端末ID（PCの場合はセッションID）
export let deviceId: any;
export function setDeviceId(val: any) { deviceId = val; }

//-----------------------------------------------------------------
// 関数定義
//-----------------------------------------------------------------
/**
 * グローバル変数の再初期化
 * ユーザーが変わった時に呼ばれる
 */
export function reInitVars()
{
    // 初期化
    today = new Date();
    minYYYYMM = "";		// 表示可能な最小年月（ユーザータイプにより決定）
    maxYYYYMM = "";		// 表示可能な最大年月（ユーザータイプにより決定）
    curYYYYMM =today.getFullYear() + Tools.padZero(today.getMonth() + 1); // 表示中の年月
    curYYYYMMDD = curYYYYMM + Tools.padZero(today.getDate()); // 表示中の年月日
    curPage = ""		// 現在表示中のページ
    rtnPage = "";		// 必要な時に戻りページIDを保存しておく
    // registeredEmail = "";   // 新規登録したメールアドレス
    // pageStack = new Array(); // ページ遷移履歴
    pageStack = []; // ページ遷移履歴
    // プロフィール退避用
    yyyy_dob = "";  // 年
    mm_dob = "";    // 月
    dd_dob = "";    // 日
    addr_j = "";     // 居住地コード（県）
    addr_o = "";     // 居住地コード（海外）
    // プロジェクト一覧取得結果一時退避変数
    // c000120Keep = "";       // プロジェクト一覧
    // c000120KeepIdx = -1;    // プロジェクト選択済みインデックス
    numOfGroupOwned = 0;    // 所有しているグループ数
    // メンバー一覧取得結果一時退避変数
    // c000040Keep = "";       // メンバー一覧
    // c000040KeepIdx = -1;    // メンバー選択済みインデックス
    // c000070Keep = "";          // ユーザー基本情報
    // s00001014_ref_objId = null; // 呼び出し元のオブジェクトID
    curPrjNo = 0;       // 選択中のプロジェクトNo
    curEventNo = 0; 	// 表示中のイベント番号
    curActNo = 0; 	    // 表示中のアクション番号
}

//-----------------------------------------------------------------
// 固定値定義
//-----------------------------------------------------------------
// Googel Map API用URL
export const mapJsApiUrl = "https://maps.googleapis.com/maps/api/js";
export const mapGeoApiUrl = "https://maps.googleapis.com/maps/api/geocode/json";

// 月
export const month_val = [
{ key: "1", val: "1" },{ key: "2", val: "2" },{ key: "3", val: "3" },{ key: "4", val: "4" },{ key: "5", val: "5" },{ key: "6", val: "6" },{ key: "7", val: "7" },{ key: "8", val: "8" },{ key: "9", val: "9" },
{ key: "10", val: "10" },{ key: "11", val: "11" },{ key: "12", val: "12" }
];
// 週
export const week_val = [
{ key: "1", val: "1" },{ key: "2", val: "2" },{ key: "3", val: "3" },{ key: "4", val: "4" },{ key: "5", val: "5" },{ key: "6", val: "6" },{ key: "7", val: "7" },{ key: "8", val: "8" },{ key: "9", val: "9" },
{ key: "10", val: "10" },{ key: "11", val: "11" },{ key: "12", val: "12" },{ key: "13", val: "13" },{ key: "14", val: "14" },{ key: "15", val: "15" },{ key: "16", val: "16" },{ key: "17", val: "17" },{ key: "18", val: "18" },{ key: "19", val: "19" },
{ key: "20", val: "20" },{ key: "21", val: "21" },{ key: "22", val: "22" },{ key: "23", val: "23" },{ key: "24", val: "24" },{ key: "25", val: "25" },{ key: "26", val: "26" },{ key: "27", val: "27" },{ key: "28", val: "28" },{ key: "29", val: "29" },
{ key: "30", val: "30" },{ key: "31", val: "31" },{ key: "32", val: "32" },{ key: "33", val: "33" },{ key: "34", val: "34" },{ key: "35", val: "35" },{ key: "36", val: "36" },{ key: "37", val: "37" },{ key: "38", val: "38" },{ key: "39", val: "39" },
{ key: "40", val: "40" },{ key: "41", val: "41" },{ key: "42", val: "42" },{ key: "43", val: "43" },{ key: "44", val: "44" },{ key: "45", val: "45" },{ key: "46", val: "46" },{ key: "47", val: "47" },{ key: "48", val: "48" },{ key: "49", val: "49" },
{ key: "50", val: "50" },{ key: "51", val: "51" },{ key: "52", val: "52" }
];
// 日
export const dd_val = [
{ key: "1", val: "1" },{ key: "2", val: "2" },{ key: "3", val: "3" },{ key: "4", val: "4" },{ key: "5", val: "5" },{ key: "6", val: "6" },{ key: "7", val: "7" },{ key: "8", val: "8" },{ key: "9", val: "9" },
{ key: "10", val: "10" },{ key: "11", val: "11" },{ key: "12", val: "12" },{ key: "13", val: "13" },{ key: "14", val: "14" },{ key: "15", val: "15" },{ key: "16", val: "16" },{ key: "17", val: "17" },{ key: "18", val: "18" },{ key: "19", val: "19" },
{ key: "20", val: "20" },{ key: "21", val: "21" },{ key: "22", val: "22" },{ key: "23", val: "23" },{ key: "24", val: "24" },{ key: "25", val: "25" },{ key: "26", val: "26" },{ key: "27", val: "27" },{ key: "28", val: "28" },{ key: "29", val: "29" },
{ key: "30", val: "30" },{ key: "31", val: "31" }
];

// 時(hh)選択リスト用
export const hh_val = [
{ key: "00:", val: "00" },{ key: "01:", val: "01" },{ key: "02:", val: "02" },{ key: "03:", val: "03" },{ key: "04:", val: "04" },{ key: "05:", val: "05" },{ key: "06:", val: "06" },{ key: "07:", val: "07" },{ key: "08:", val: "08" },{ key: "09:", val: "09" },{ key: "10:", val: "10" },{ key: "11:", val: "11" },{ key: "12:", val: "12" },{ key: "13:", val: "13" },{ key: "14:", val: "14" },{ key: "15:", val: "15" },{ key: "16:", val: "16" },{ key: "17:", val: "17" },{ key: "18:", val: "18" },{ key: "19:", val: "19" },{ key: "20:", val: "20" },{ key: "21:", val: "21" },{ key: "22:", val: "22" },{ key: "23:", val: "23" }
];
export const hh2_val = [{ key: "", val: "-1" },
{ key: "00:", val: "00" },{ key: "01:", val: "01" },{ key: "02:", val: "02" },{ key: "03:", val: "03" },{ key: "04:", val: "04" },{ key: "05:", val: "05" },{ key: "06:", val: "06" },{ key: "07:", val: "07" },{ key: "08:", val: "08" },{ key: "09:", val: "09" },{ key: "10:", val: "10" },{ key: "11:", val: "11" },{ key: "12:", val: "12" },{ key: "13:", val: "13" },{ key: "14:", val: "14" },{ key: "15:", val: "15" },{ key: "16:", val: "16" },{ key: "17:", val: "17" },{ key: "18:", val: "18" },{ key: "19:", val: "19" },{ key: "20:", val: "20" },{ key: "21:", val: "21" },{ key: "22:", val: "22" },{ key: "23:", val: "23" }
];
// 分(mm)選択リスト用
export const mm_val = [
{ key: "00", val: "00" },{ key: "01", val: "01" },{ key: "02", val: "02" },{ key: "03", val: "03" },{ key: "04", val: "04" },{ key: "05", val: "05" },{ key: "06", val: "06" },{ key: "07", val: "07" },{ key: "08", val: "08" },{ key: "09", val: "09" },{ key: "10", val: "10" },{ key: "11", val: "11" },{ key: "12", val: "12" },{ key: "13", val: "13" },{ key: "14", val: "14" },{ key: "15", val: "15" },{ key: "16", val: "16" },{ key: "17", val: "17" },{ key: "18", val: "18" },{ key: "19", val: "19" },
{ key: "20", val: "20" },{ key: "21", val: "21" },{ key: "22", val: "22" },{ key: "23", val: "23" },{ key: "24", val: "24" },{ key: "25", val: "25" },{ key: "26", val: "26" },{ key: "27", val: "27" },{ key: "28", val: "28" },{ key: "29", val: "29" },{ key: "30", val: "30" },{ key: "31", val: "31" },{ key: "32", val: "32" },{ key: "33", val: "33" },{ key: "34", val: "34" },{ key: "35", val: "35" },{ key: "36", val: "36" },{ key: "37", val: "37" },{ key: "38", val: "38" },{ key: "39", val: "39" },
{ key: "40", val: "40" },{ key: "41", val: "41" },{ key: "42", val: "42" },{ key: "43", val: "43" },{ key: "44", val: "44" },{ key: "45", val: "45" },{ key: "46", val: "46" },{ key: "47", val: "47" },{ key: "48", val: "48" },{ key: "49", val: "49" },{ key: "50", val: "50" },{ key: "51", val: "51" },{ key: "52", val: "52" },{ key: "53", val: "53" },{ key: "54", val: "54" },{ key: "55", val: "55" },{ key: "56", val: "56" },{ key: "57", val: "57" },{ key: "58", val: "58" },{ key: "59", val: "59" }
];
export const mm2_val = [{ key: "", val: "-1" },
{ key: "00", val: "00" },{ key: "01", val: "01" },{ key: "02", val: "02" },{ key: "03", val: "03" },{ key: "04", val: "04" },{ key: "05", val: "05" },{ key: "06", val: "06" },{ key: "07", val: "07" },{ key: "08", val: "08" },{ key: "09", val: "09" },{ key: "10", val: "10" },{ key: "11", val: "11" },{ key: "12", val: "12" },{ key: "13", val: "13" },{ key: "14", val: "14" },{ key: "15", val: "15" },{ key: "16", val: "16" },{ key: "17", val: "17" },{ key: "18", val: "18" },{ key: "19", val: "19" },
{ key: "20", val: "20" },{ key: "21", val: "21" },{ key: "22", val: "22" },{ key: "23", val: "23" },{ key: "24", val: "24" },{ key: "25", val: "25" },{ key: "26", val: "26" },{ key: "27", val: "27" },{ key: "28", val: "28" },{ key: "29", val: "29" },{ key: "30", val: "30" },{ key: "31", val: "31" },{ key: "32", val: "32" },{ key: "33", val: "33" },{ key: "34", val: "34" },{ key: "35", val: "35" },{ key: "36", val: "36" },{ key: "37", val: "37" },{ key: "38", val: "38" },{ key: "39", val: "39" },
{ key: "40", val: "40" },{ key: "41", val: "41" },{ key: "42", val: "42" },{ key: "43", val: "43" },{ key: "44", val: "44" },{ key: "45", val: "45" },{ key: "46", val: "46" },{ key: "47", val: "47" },{ key: "48", val: "48" },{ key: "49", val: "49" },{ key: "50", val: "50" },{ key: "51", val: "51" },{ key: "52", val: "52" },{ key: "53", val: "53" },{ key: "54", val: "54" },{ key: "55", val: "55" },{ key: "56", val: "56" },{ key: "57", val: "57" },{ key: "58", val: "58" },{ key: "59", val: "59" }
];
// 県リスト用
export const ken_val = [{ "key": "01", "val": "北海道"},{ "key": "02", "val": "青森県"},{ "key": "03", "val": "岩手県"},{ "key": "04", "val": "宮城県"},{ "key": "05", "val": "秋田県"},{ "key": "06", "val": "山形県"},{ "key": "07", "val": "福島県"},{ "key": "08", "val": "茨城県"},{ "key": "09", "val": "栃木県"},{ "key": "10", "val": "群馬県"},{ "key": "11", "val": "埼玉県"},{ "key": "12", "val": "千葉県"},{ "key": "13", "val": "東京都"},{ "key": "14", "val": "神奈川県"},{ "key": "15", "val": "新潟県"},{ "key": "16", "val": "富山県"},{ "key": "17", "val": "石川県"},{ "key": "18", "val": "福井県"},{ "key": "19", "val": "山梨県"},{ "key": "20", "val": "長野県"},{ "key": "21", "val": "岐阜県"},{ "key": "22", "val": "静岡県"},{ "key": "23", "val": "愛知県"},{ "key": "24", "val": "三重県"},{ "key": "25", "val": "滋賀県"},{ "key": "26", "val": "京都府"},{ "key": "27", "val": "大阪府"},{ "key": "28", "val": "兵庫県"},{ "key": "29", "val": "奈良県"},{ "key": "30", "val": "和歌山県"},{ "key": "31", "val": "鳥取県"},{ "key": "32", "val": "島根県"},{ "key": "33", "val": "岡山県"},{ "key": "34", "val": "広島県"},{ "key": "35", "val": "山口県"},{ "key": "36", "val": "徳島県"},{ "key": "37", "val": "香川県"},{ "key": "38", "val": "愛媛県"},{ "key": "39", "val": "高知県"},{ "key": "40", "val": "福岡県"},{ "key": "41", "val": "佐賀県"},{ "key": "42", "val": "長崎県"},{ "key": "43", "val": "熊本県"},{ "key": "44", "val": "大分県"},{ "key": "45", "val": "宮崎県"},{ "key": "46", "val": "鹿児島県"},{ "key": "47", "val": "沖縄県"},{ "key": "99", "val": "海外"}];
// 国リスト用
export const country_val = [{ "key": "US", "val": "UNITED STATES"},{ "key": "AF", "val": "AFGHANISTAN"},{ "key": "AX", "val": "ALAND ISLANDS"},{ "key": "AL", "val": "ALBANIA"},{ "key": "DZ", "val": "ALGERIA"},{ "key": "AS", "val": "AMERICAN SAMOA"},{ "key": "AD", "val": "ANDORRA"},{ "key": "AO", "val": "ANGOLA"},{ "key": "AI", "val": "ANGUILLA"},{ "key": "AQ", "val": "ANTARCTICA"},{ "key": "AG", "val": "ANTIGUA AND BARBUDA"},{ "key": "AR", "val": "ARGENTINA"},{ "key": "AM", "val": "ARMENIA"},{ "key": "AW", "val": "ARUBA"},{ "key": "AU", "val": "AUSTRALIA"},{ "key": "AT", "val": "AUSTRIA"},{ "key": "AZ", "val": "AZERBAIJAN"},{ "key": "BS", "val": "BAHAMAS"},{ "key": "BH", "val": "BAHRAIN"},{ "key": "BD", "val": "BANGLADESH"},{ "key": "BB", "val": "BARBADOS"},{ "key": "BY", "val": "BELARUS"},{ "key": "BE", "val": "BELGIUM"},{ "key": "BZ", "val": "BELIZE"},{ "key": "BJ", "val": "BENIN"},{ "key": "BM", "val": "BERMUDA"},{ "key": "BT", "val": "BHUTAN"},{ "key": "BO", "val": "BOLIVIA"},{ "key": "BA", "val": "BOSNIA AND HERZEGOVINA"},{ "key": "BW", "val": "BOTSWANA"},{ "key": "BV", "val": "BOUVET ISLAND"},{ "key": "BR", "val": "BRAZIL"},{ "key": "IO", "val": "BRITISH INDIAN OCEAN TERRITORY"},{ "key": "BN", "val": "BRUNEI DARUSSALAM"},{ "key": "BG", "val": "BULGARIA"},{ "key": "BF", "val": "BURKINA FASO"},{ "key": "BI", "val": "BURUNDI"},{ "key": "KH", "val": "CAMdobIA"},{ "key": "CM", "val": "CAMEROON"},{ "key": "CA", "val": "CANADA"},{ "key": "CV", "val": "CAPE VERDE"},{ "key": "KY", "val": "CAYMAN ISLANDS"},{ "key": "CF", "val": "CENTRAL AFRICAN REPUBLIC"},{ "key": "TD", "val": "CHAD"},{ "key": "CL", "val": "CHILE"},{ "key": "CN", "val": "CHINA"},{ "key": "CX", "val": "CHRISTMAS ISLAND"},{ "key": "CC", "val": "COCOS (KEELING) ISLANDS"},{ "key": "CO", "val": "COLOMBIA"},{ "key": "KM", "val": "COMOROS"},{ "key": "CG", "val": "CONGO"},{ "key": "CD", "val": "CONGO, THE DEMOCRATIC REPUBLIC OF THE"},{ "key": "CK", "val": "COOK ISLANDS"},{ "key": "CR", "val": "COSTA RICA"},{ "key": "CI", "val": "COTE D'IVOIRE"},{ "key": "HR", "val": "CROATIA"},{ "key": "CU", "val": "CUBA"},{ "key": "CY", "val": "CYPRUS"},{ "key": "CZ", "val": "CZECH REPUBLIC"},{ "key": "DK", "val": "DENMARK"},{ "key": "DJ", "val": "DJIBOUTI"},{ "key": "DM", "val": "DOMINICA"},{ "key": "DO", "val": "DOMINICAN REPUBLIC"},{ "key": "EC", "val": "ECUADOR"},{ "key": "EG", "val": "EGYPT"},{ "key": "SV", "val": "EL SALVADOR"},{ "key": "GQ", "val": "EQUATORIAL GUINEA"},{ "key": "ER", "val": "ERITREA"},{ "key": "EE", "val": "ESTONIA"},{ "key": "ET", "val": "ETHIOPIA"},{ "key": "FK", "val": "FALKLAND ISLANDS (MALVINAS)"},{ "key": "FO", "val": "FAROE ISLANDS"},{ "key": "FJ", "val": "FIJI"},{ "key": "FI", "val": "FINLAND"},{ "key": "FR", "val": "FRANCE"},{ "key": "GF", "val": "FRENCH GUIANA"},{ "key": "PF", "val": "FRENCH POLYNESIA"},{ "key": "TF", "val": "FRENCH SOUTHERN TERRITORIES"},{ "key": "GA", "val": "GABON"},{ "key": "GM", "val": "GAMBIA"},{ "key": "GE", "val": "GEORGIA"},{ "key": "DE", "val": "GERMANY"},{ "key": "GH", "val": "GHANA"},{ "key": "GI", "val": "GIBRALTAR"},{ "key": "GR", "val": "GREECE"},{ "key": "GL", "val": "GREENLAND"},{ "key": "GD", "val": "GRENADA"},{ "key": "GP", "val": "GUADELOUPE"},{ "key": "GU", "val": "GUAM"},{ "key": "GT", "val": "GUATEMALA"},{ "key": "GN", "val": "GUINEA"},{ "key": "GW", "val": "GUINEA-BISSAU"},{ "key": "GY", "val": "GUYANA"},{ "key": "HT", "val": "HAITI"},{ "key": "HM", "val": "HEARD ISLAND AND MCDONALD ISLANDS"},{ "key": "VA", "val": "HOLY SEE (VATICAN CITY STATE)"},{ "key": "HN", "val": "HONDURAS"},{ "key": "HK", "val": "HONG KONG"},{ "key": "HU", "val": "HUNGARY"},{ "key": "IS", "val": "ICELAND"},{ "key": "IN", "val": "INDIA"},{ "key": "ID", "val": "INDONESIA"},{ "key": "IR", "val": "IRAN, ISLAMIC REPUBLIC OF"},{ "key": "IQ", "val": "IRAQ"},{ "key": "IE", "val": "IRELAND"},{ "key": "IL", "val": "ISRAEL"},{ "key": "IT", "val": "ITALY"},{ "key": "JM", "val": "JAMAICA"},{ "key": "JO", "val": "JORDAN"},{ "key": "JP", "val": "JAPAN"},{ "key": "KZ", "val": "KAZAKHSTAN"},{ "key": "KE", "val": "KENYA"},{ "key": "KI", "val": "KIRIBATI"},{ "key": "KP", "val": "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF"},{ "key": "KR", "val": "KOREA, REPUBLIC OF"},{ "key": "KW", "val": "KUWAIT"},{ "key": "KG", "val": "KYRGYZSTAN"},{ "key": "LA", "val": "LAO PEOPLE'S DEMOCRATIC REPUBLIC"},{ "key": "LV", "val": "LATVIA"},{ "key": "LB", "val": "LEBANON"},{ "key": "LS", "val": "LESOTHO"},{ "key": "LR", "val": "LIBERIA"},{ "key": "LY", "val": "LIBYAN ARAB JAMAHIRIYA"},{ "key": "LI", "val": "LIECHTENSTEIN"},{ "key": "LT", "val": "LITHUANIA"},{ "key": "LU", "val": "LUXEMBOURG"},{ "key": "MO", "val": "MACAO"},{ "key": "MK", "val": "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF"},{ "key": "MG", "val": "MADAGASCAR"},{ "key": "MW", "val": "MALAWI"},{ "key": "MY", "val": "MALAYSIA"},{ "key": "MV", "val": "MALDIVES"},{ "key": "ML", "val": "MALI"},{ "key": "MT", "val": "MALTA"},{ "key": "MH", "val": "MARSHALL ISLANDS"},{ "key": "MQ", "val": "MARTINIQUE"},{ "key": "MR", "val": "MAURITANIA"},{ "key": "MU", "val": "MAURITIUS"},{ "key": "YT", "val": "MAYOTTE"},{ "key": "MX", "val": "MEXICO"},{ "key": "FM", "val": "MICRONESIA, FEDERATED STATES OF"},{ "key": "MD", "val": "MOLDOVA, REPUBLIC OF"},{ "key": "MC", "val": "MONACO"},{ "key": "MN", "val": "MONGOLIA"},{ "key": "MS", "val": "MONTSERRAT"},{ "key": "MA", "val": "MOROCCO"},{ "key": "MZ", "val": "MOZAMBIQUE"},{ "key": "MM", "val": "MYANMAR"},{ "key": "NA", "val": "NAMIBIA"},{ "key": "NR", "val": "NAURU"},{ "key": "NP", "val": "NEPAL"},{ "key": "NL", "val": "NETHERLANDS"},{ "key": "AN", "val": "NETHERLANDS ANTILLES"},{ "key": "NC", "val": "NEW CALEDONIA"},{ "key": "NZ", "val": "NEW ZEALAND"},{ "key": "NI", "val": "NICARAGUA"},{ "key": "NE", "val": "NIGER"},{ "key": "NG", "val": "NIGERIA"},{ "key": "NU", "val": "NIUE"},{ "key": "NF", "val": "NORFOLK ISLAND"},{ "key": "MP", "val": "NORTHERN MARIANA ISLANDS"},{ "key": "NO", "val": "NORWAY"},{ "key": "OM", "val": "OMAN"},{ "key": "PK", "val": "PAKISTAN"},{ "key": "PW", "val": "PALAU"},{ "key": "PS", "val": "PALESTINIAN TERRITORY, OCCUPIED"},{ "key": "PA", "val": "PANAMA"},{ "key": "PG", "val": "PAPUA NEW GUINEA"},{ "key": "PY", "val": "PARAGUAY"},{ "key": "PE", "val": "PERU"},{ "key": "PH", "val": "PHILIPPINES"},{ "key": "PN", "val": "PITCAIRN"},{ "key": "PL", "val": "POLAND"},{ "key": "PT", "val": "PORTUGAL"},{ "key": "PR", "val": "PUERTO RICO"},{ "key": "QA", "val": "QATAR"},{ "key": "RE", "val": "REUNION"},{ "key": "RO", "val": "ROMANIA"},{ "key": "RU", "val": "RUSSIAN FEDERATION"},{ "key": "RW", "val": "RWANDA"},{ "key": "SH", "val": "SAINT HELENA"},{ "key": "KN", "val": "SAINT KITTS AND NEVIS"},{ "key": "LC", "val": "SAINT LUCIA"},{ "key": "PM", "val": "SAINT PIERRE AND MIQUELON"},{ "key": "VC", "val": "SAINT VINCENT AND THE GRENADINES"},{ "key": "WS", "val": "SAMOA"},{ "key": "SM", "val": "SAN MARINO"},{ "key": "ST", "val": "SAO TOME AND PRINCIPE"},{ "key": "SA", "val": "SAUDI ARABIA"},{ "key": "SN", "val": "SENEGAL"},{ "key": "CS", "val": "SERBIA AND MONTENEGRO"},{ "key": "SC", "val": "SEYCHELLES"},{ "key": "SL", "val": "SIERRA LEONE"},{ "key": "SG", "val": "SINGAPORE"},{ "key": "SK", "val": "SLOVAKIA"},{ "key": "SI", "val": "SLOVENIA"},{ "key": "SB", "val": "SOLOMON ISLANDS"},{ "key": "SO", "val": "SOMALIA"},{ "key": "ZA", "val": "SOUTH AFRICA"},{ "key": "GS", "val": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS"},{ "key": "ES", "val": "SPAIN"},{ "key": "LK", "val": "SRI LANKA"},{ "key": "SD", "val": "SUDAN"},{ "key": "SR", "val": "SURINAME"},{ "key": "SJ", "val": "SVALBARD AND JAN MAYEN"},{ "key": "SZ", "val": "SWAZILAND"},{ "key": "SE", "val": "SWEDEN"},{ "key": "CH", "val": "SWITZERLAND"},{ "key": "SY", "val": "SYRIAN ARAB REPUBLIC"},{ "key": "TW", "val": "TAIWAN, PROVINCE OF CHINA"},{ "key": "TJ", "val": "TAJIKISTAN"},{ "key": "TZ", "val": "TANZANIA, UNITED REPUBLIC OF"},{ "key": "TH", "val": "THAILAND"},{ "key": "TL", "val": "TIMOR-LESTE"},{ "key": "TG", "val": "TOGO"},{ "key": "TK", "val": "TOKELAU"},{ "key": "TO", "val": "TONGA"},{ "key": "TT", "val": "TRINIDAD AND TOBAGO"},{ "key": "TN", "val": "TUNISIA"},{ "key": "TR", "val": "TURKEY"},{ "key": "TM", "val": "TURKMENISTAN"},{ "key": "TC", "val": "TURKS AND CAICOS ISLANDS"},{ "key": "TV", "val": "TUVALU"},{ "key": "UG", "val": "UGANDA"},{ "key": "UA", "val": "UKRAINE"},{ "key": "AE", "val": "UNITED ARAB EMIRATES"},{ "key": "GB", "val": "UNITED KINGDOM"},{ "key": "UM", "val": "UNITED STATES MINOR OUTLYING ISLANDS"},{ "key": "UY", "val": "URUGUAY"},{ "key": "UZ", "val": "UZBEKISTAN"},{ "key": "VU", "val": "VANUATU"},{ "key": "VE", "val": "VENEZUELA"},{ "key": "VN", "val": "VIET NAM"},{ "key": "VG", "val": "VIRGIN ISLANDS, BRITISH"},{ "key": "VI", "val": "VIRGIN ISLANDS, U.S."},{ "key": "WF", "val": "WALLIS AND FUTUNA"},{ "key": "EH", "val": "WESTERN SAHARA"},{ "key": "YE", "val": "YEMEN"},{ "key": "ZM", "val": "ZAMBIA"},{ "key": "ZW", "val": "ZIMBABWE"}];
// リマインダー用
export const remind_dd_val = [{ key: "日", val: -1 },
{ key: "当日", val: 0 },{ key: "1日", val: 1 },{ key: "2日", val: 2 },{ key: "3日", val: 3 },{ key: "4日", val: 4 },{ key: "5日", val: 5 },{ key: "6日", val: 6 },{ key: "7日", val: 7 },{ key: "8日", val: 8 },{ key: "9日", val: 9 },
{ key: "10日", val: 10 },{ key: "11日", val: 11 },{ key: "12日", val: 12 },{ key: "13日", val: 13 },{ key: "14日", val: 14 },{ key: "15日", val: 15 },{ key: "16日", val: 16 },{ key: "17日", val: 17 },{ key: "18日", val: 18 },{ key: "19日", val: 19 },
{ key: "20日", val: 20 },{ key: "21日", val: 21 },{ key: "22日", val: 22 },{ key: "23日", val: 23 },{ key: "24日", val: 24 },{ key: "25日", val: 25 },{ key: "26日", val: 26 },{ key: "27日", val: 27 },{ key: "28日", val: 28 },{ key: "29日", val: 29 },
{ key: "30日", val: 30 },{ key: "31日", val: 31 }
];
export const remind_hr_val = [{ key: "時", val: -1 },
{ key: "0時間", val: 0 },{ key: "1時間", val: 1 },{ key: "2時間", val: 2 },{ key: "3時間", val: 3 },{ key: "4時間", val: 4 },{ key: "5時間", val: 5 },{ key: "6時間", val: 6 },{ key: "7時間", val: 7 },{ key: "8時間", val: 8 },{ key: "9時間", val: 9 },
{ key: "10時間", val: 10 },{ key: "11時間", val: 11 },{ key: "12時間", val: 12 },{ key: "13時間", val: 13 },{ key: "14時間", val: 14 },{ key: "15時間", val: 15 },{ key: "16時間", val: 16 },{ key: "17時間", val: 17 },{ key: "18時間", val: 18 },{ key: "19時間", val: 19 },
{ key: "20時間", val: 20 },{ key: "21時間", val: 21 },{ key: "22時間", val: 22 },{ key: "23時間", val: 23 }
];
export const remind_mm_val = [{ key: "分", val: -1 },
{ key: "0分", val: 0 },{ key: "1分", val: 1 },{ key: "2分", val: 2 },{ key: "3分", val: 3 },{ key: "4分", val: 4 },{ key: "5分", val: 5 },{ key: "6分", val: 6 },{ key: "7分", val: 7 },{ key: "8分", val: 8 },{ key: "9分", val: 9 },{ key: "10分", val: 10 },{ key: "11分", val: 11 },{ key: "12分", val: 12 },{ key: "13分", val: 13 },{ key: "14分", val: 14 },{ key: "15分", val: 15 },{ key: "16分", val: 16 },{ key: "17分", val: 17 },{ key: "18分", val: 18 },{ key: "19分", val: 19 },
{ key: "20分", val: 20 },{ key: "21分", val: 21 },{ key: "22分", val: 22 },{ key: "23分", val: 23 },{ key: "24分", val: 24 },{ key: "25分", val: 25 },{ key: "26分", val: 26 },{ key: "27分", val: 27 },{ key: "28分", val: 28 },{ key: "29分", val: 29 },{ key: "30分", val: 30 },{ key: "31分", val: 31 },{ key: "32分", val: 32 },{ key: "33分", val: 33 },{ key: "34分", val: 34 },{ key: "35分", val: 35 },{ key: "36分", val: 36 },{ key: "37分", val: 37 },{ key: "38分", val: 38 },{ key: "39分", val: 39 },
{ key: "40分", val: 40 },{ key: "41分", val: 41 },{ key: "42分", val: 42 },{ key: "43分", val: 43 },{ key: "44分", val: 44 },{ key: "45分", val: 45 },{ key: "46分", val: 46 },{ key: "47分", val: 47 },{ key: "48分", val: 48 },{ key: "49分", val: 49 },{ key: "50分", val: 50 },{ key: "51分", val: 51 },{ key: "52分", val: 52 },{ key: "53分", val: 53 },{ key: "54分", val: 54 },{ key: "55分", val: 55 },{ key: "56分", val: 56 },{ key: "57分", val: 57 },{ key: "58分", val: 58 },{ key: "59分", val: 59 }
];
// 出席確率
export const event_psblty_val = [{ key: "-", val: -1 },
{ key: "0%", val: 0 },{ key: "25%", val: 25 },{ key: "50%", val: 50 },{ key: "75%", val: 75 },{ key: "99%", val: 99 }
];

//-----------------------------------------------------------------
// 固定値(デバイス依存)
// 連想配列は次のkeyで作成する。Andorid: ANDROID, iOS: IOS, その他: OTHERS
//-----------------------------------------------------------------
// Google Map用API Key
export const apiKeys: any = {android: "AIzaSyBWIbZDIypKgOlfKMIA5EoAAKUsjC603UM",  // Android
                 ios: "AIzaSyBjHBrNrzl3-RnIq9jdK0KuqTDCcgvMeek",      // iOS
                 web: "AIzaSyAJaYFN5k5Fw1-GyIkT_BWsxZjnCOjkQ7M"};     // その他

//-----------------------------------------------------------------
// 環境依存（各システムのinitで設定する）
//-----------------------------------------------------------------
export let sysCd = "";       // システムコード
export function setSysCd(val: string) {sysCd=val;}

export let tmpltCd = "";    // テンプレートコード
export function setTmpltCd(val: string) {tmpltCd=val;}

// export let menuPage = "";  // メニューページ
// export function setMenuPage(val: string) {menuPage=val;}

export let loginPage = "";   // ログインページ
export function setLoginPage(val: string) {loginPage=val;}

export let topPage = "";   // ログインして最初に表示するページ
export function setTopPage(val: string) {topPage=val;}

// 開発（Chrome）：DEV、 検証(AVD)：TST、 本番：PRD
export let env = "DEV";
export function setEnv(val: string) {env=val;}

// SpringBoot用
// 旧サーブレット用
export let serverUrl = "";
export function setServerUrl(val: string ) { serverUrl = val; }
export function getServerUrl() { return serverUrl; }
// 新サーブレット用
export let serverUrl2 = "";
export function setServerUrl2(val: string ) { serverUrl2 = val; }
export function getServerUrl2() { return serverUrl2; }
// // 旧サーブレット用
// export let serverUrl: {[key:string]: string} ;
// export function setServerUrl(val: {[key:string]: string} ) {serverUrl=val;}
// export function getServerUrl() {return serverUrl[env];}
// // 新サーブレット用
// export let serverUrl2: {[key:string]: string} ;
// export function setServerUrl2(val: {[key:string]: string} ) {serverUrl2=val;}
// export function getServerUrl2() {return serverUrl2[env];}


//-----------------------------------------------------------------
// 画面間パラメーター定義
//-----------------------------------------------------------------

// S00001002 ログイン情報
export let s00001002Params: any;
export function setS00001002Params(val: any) { s00001002Params = val; }

// S00001008 ログアウト確認ページ
export let s00001008Msg = "";
export function setS00001008Msg(val: string) {s00001008Msg = val;}

// S00001012 メッセージ表示ページ１
export class  s00001012Msg
{
    title = ""; // タイトル
    body = "";  // 本文
    constructor(title: string, body: string)
    {
        this.title = title;
        this.body = body;
    }
}
export let s00001012Msgs: s00001012Msg[];
export function setS00001012Msgs(val: s00001012Msg[]) {s00001012Msgs = val;}
export let s00001012Nextpage: string;   // お知らせ表示後の遷移先
export function setS00001012Nextpage(val: string) {s00001012Nextpage = val;}

// S00001014 入力項目選択ページ
export let s00001014RefObjId = ""; // 呼び出し元のオブジェクトID
export function setS00001014RefObjId(val: string) {s00001014RefObjId = val;}
export let s00001014Value = ""; // 入力値
export function setS00001014Value(val: string) {s00001014Value = val;}

// S00001015 地図全画面表示ページ(iOSのみ）
export let s00001015Addr = ""; // 地図に表示する住所
export function setS00001015Addr(val: string) {s00001015Addr = val;}
export let s00001015Desc = ""; // 地図に表示する住所
export function setS00001015Desc(val: string) {s00001015Desc = val;}

// S0000110 マンスリーカレンダー表示用
// export let s00001101PrjNo = -1;  // プロジェクトNo.
// export function setS00001101PrjNo(val: number) {s00001101PrjNo = val;}
/*
export let s00001101Fym = "";    // カレンダー取得開始年月(YYYYMM)
export function setS00001101Fym(val: string) {s00001101Fym = val;}
export let s00001101Tym = "";    // カレンダー取得終了年月(YYYYMM)
export function setS00001101Tym(val: string) {s00001101Tym = val;}
export let s00001101Ymd = "";    // 当日の年月日(YYYYMMDD)
export function setS00001101Ymd(val: string) {s00001101Ymd = val;}
*/

// export let s00001014Params = 
// 	new class S00001014Param
// 	{
// 		sysCd = "";
// 		tmpltCd = ""; 
// 		pnlId = ""; 
// 		objId = ""; 
// 		placeholder = "";
// 	}
// export let s00001014Params: any;
// export function setS00001014Params(val: any) { s00001014Params = val; }